import Cookies from "js-cookie"

export const CondoUID = Cookies.get("condoUID")
